import {
  Component,
  Input,
  Output,
  EventEmitter,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Import FormsModule for ngModel

@Component({
  selector: 'app-dropdown',
  imports: [SelectModule, CommonModule, FormsModule], // Declare imports here
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() options: any[] = [];
  @Input() selectedValue: any;
  @Input() placeholder: string = 'Select';
  @Input() label: string = '';
  @Input() customClass: string = '';
  //@Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Output() selectedValueChange = new EventEmitter<any>(); // Correct Output binding for two-way binding

  onValueChange(event: any) {
    this.selectedValue = event.value;
    this.selectedValueChange.emit(event.value); // Emit event for two-way binding
  }
}
